import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        // Detect environment to set URL (localhost vs production)
        let URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

        // Fix malformed URL: Remove /api, trailing slashes, AND ensure no double protocol (e.g. wss://https://)
        // If URL starts with http/https, socket.io-client handles it. We just need the base domain.
        const socketUrl = URL.replace(/\/api\/?$/, '').replace(/\/$/, '');

        console.log('Initializing Socket.io connection to:', socketUrl);

        const newSocket = io(socketUrl, {
            path: '/socket.io',
            transports: ['polling', 'websocket'],
            withCredentials: true,
            auth: {
                token: localStorage.getItem('userToken') // Pass token for server-side auth
            },
            autoConnect: true,
            reconnection: true,
        });

        setSocket(newSocket);

        // Debug connection
        newSocket.on('connect', () => {
            console.log('Socket connected:', newSocket.id);
            // Server now handles joining rooms automatically based on the authenticated token
        });

        newSocket.on('connect_error', (err) => {
            console.error('Socket connection error:', err);
        });

        return () => newSocket.close();
    }, []);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};
